import React from 'react';
import './App.css';
import AppRouter from './config/router';
import "bootstrap/dist/css/bootstrap.min.css";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
function App() {
  return <AppRouter />
}

export default App;
